import { render, staticRenderFns } from "./ClaimClaimant.vue?vue&type=template&id=dfaf5d9c&"
import script from "./ClaimClaimant.vue?vue&type=script&lang=js&"
export * from "./ClaimClaimant.vue?vue&type=script&lang=js&"
import style0 from "./ClaimClaimant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimClaimant.vue"
export default component.exports